import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../css/Login.css";
import Logo from "../image/LogoSenaGestor.png";
import { useUsuarios } from "../context/UsuariosContext";

const Login = () => {
  const navigate = useNavigate();
  const { loading, loginUsuarios } = useUsuarios();

  const [emailInstructor, setEmailInstructor] = useState("");
  const [passwordInstructor, setPasswordInstructor] = useState("");
  const [showPass, setShowPass] = useState(false);

  const login = (e) => {
    e.preventDefault();

    if (!emailInstructor.trim() || !passwordInstructor.trim()) {
      return Swal.fire({
        icon: "warning",
        title: "Campos requeridos",
        text: "Debes ingresar tu correo y contraseña",
      });
    }

    const instructor = {
      emailInstructor: emailInstructor.trim(),
      passwordInstructor,
    };

    loginUsuarios(instructor, navigate);
  };

  return (
    <div className="creative-login">
      <div className="creative-bg-blur" />

      <div className="creative-card">
        <div className="creative-left">
          <div className="creative-logo-container">
            <img src={Logo} alt="Mr Gestor" />
            <p>Sistema Integral de Gestión Documental & Académica</p>
          </div>

          <div className="creative-features">
            <div>✔ Gestión institucional</div>
            <div>✔ Control de instructores y aprendices</div>
            <div>✔ Reportes y seguimiento</div>
          </div>
        </div>

        <div className="creative-right">
          <div className="creative-mobile-brand">
            <div className="creative-mobile-logo">
              <img src={Logo} alt="Mr Gestor" />
            </div>
          </div>

          <h3>Bienvenido</h3>
          <p>Ingresa tus credenciales para continuar</p>

          <form onSubmit={login}>
            <div className="mb-2">
              <label>Correo</label>
              <input
                className="form-control"
                type="email"
                placeholder="nombre@correo.com"
                required
                autoFocus
                onChange={(e) => setEmailInstructor(e.target.value)}
                value={emailInstructor}
                disabled={loading}
              />
            </div>

            <div className="mb-3">
              <label>Contraseña</label>
              <div className="password-wrapper">
                <input
                  className="form-control"
                  type={showPass ? "text" : "password"}
                  placeholder="••••••••"
                  required
                  onChange={(e) => setPasswordInstructor(e.target.value)}
                  value={passwordInstructor}
                  disabled={loading}
                />
                <span
                  onClick={() => !loading && setShowPass(!showPass)}
                  style={{ cursor: loading ? "not-allowed" : "pointer" }}
                >
                  {showPass ? "Ocultar" : "Ver"}
                </span>
              </div>
            </div>

            <div className="mb-3">
              <button
                className="btn btn-primary d-block w-100"
                type="submit"
                disabled={loading}
              >
                {loading ? "Ingresando..." : "Ingresar"}
              </button>
            </div>
          </form>

          <div className="creative-footer">
            <strong>iCS - Ingenieria Colombianas de Systemas</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;